import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.string.starts-with.js";
import "core-js/modules/es6.function.name.js";
import "regenerator-runtime/runtime.js";
import ICountUp from 'vue-countup-v2';
import Nl2br from 'vue-nl2br';
import { EthereumNetwork, HomeverseNetwork, MaticNetwork, OasysMainnet } from '@/lib/wallet';
import { useWalletStore } from '@/stores/useWalletStore';
var SubMenu = function SubMenu() {
  return import('~/components/molecules/SubMenu');
};
var PageTitleDisplay = function PageTitleDisplay() {
  return import('~/components/molecules/PageTitleDisplay');
};
var ReportList = function ReportList() {
  return import('~/components/molecules/ReportList');
};
var SoundSetting = function SoundSetting() {
  return import('~/components/atoms/SoundSetting');
};
var Modal = function Modal() {
  return import('~/components/organisms/Modal');
};
var RecoveryStaminaModal = function RecoveryStaminaModal() {
  return import('~/components/organisms/RecoveryStaminaModal');
};
var NoneSwitchNetworkModal = function NoneSwitchNetworkModal() {
  return import('~/components/organisms/NoneSwitchNetworkModal');
};
export default {
  components: {
    SubMenu: SubMenu,
    ICountUp: ICountUp,
    PageTitleDisplay: PageTitleDisplay,
    ReportList: ReportList,
    SoundSetting: SoundSetting,
    Modal: Modal,
    Nl2br: Nl2br,
    RecoveryStaminaModal: RecoveryStaminaModal,
    NoneSwitchNetworkModal: NoneSwitchNetworkModal
  },
  props: {
    isShowTitle: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      isMenuShown: false,
      raidBossHp: 0,
      isLangDropdownShown: false,
      timerCount: 0,
      targetItemId: 0,
      accordionMenuOpen: false,
      isRecoveryStaminaModalShown: false,
      isNoneSwitchNetworkModal: false
    };
  },
  computed: {
    isError: function isError() {
      return useAuthStore().getIsError;
    },
    me: function me() {
      return useUserStore().me;
    },
    messagesUnreadCount: function messagesUnreadCount() {
      return useMessageStore().getUnreadCount;
    },
    announcementUnreadCount: function announcementUnreadCount() {
      return useAnnouncementStore().getUnreadCount;
    },
    reports: function reports() {
      return useReportStore().getReports;
    },
    userId: function userId() {
      return useAuthStore().getUserId;
    },
    isLoggedIn: function isLoggedIn() {
      return useAuthStore().isLoggedIn;
    },
    myZel: function myZel() {
      return useGumStore().myZel;
    },
    networkBool: function networkBool() {
      return useAuthStore().getNetworkBool;
    },
    netId: function netId() {
      return useAuthStore().getNetId;
    },
    userProfilePic: function userProfilePic() {
      if (this.me.ipfs) {
        return "".concat(this.$env.cdnUrl, "/user_arts/").concat(this.me.ipfs);
      }
      return '';
    },
    notificationUnreadCount: function notificationUnreadCount() {
      return this.messagesUnreadCount + this.announcementUnreadCount;
    },
    headerTopHeight: function headerTopHeight() {
      return this.$el.querySelector('.appHeader__top').clientHeight;
    },
    subMenuStyles: function subMenuStyles() {
      return {
        'margin-top': "".concat(this.headerTopHeight, "px"),
        height: "calc(100% - ".concat(this.headerTopHeight, "px)")
      };
    },
    landType: function landType() {
      return (this.me || {}).landType;
    },
    landUrl: function landUrl() {
      return this.landType ? this.localePath({
        name: 'land-landType',
        params: {
          landType: this.landType
        }
      }) : this.localePath('land');
    },
    isQuestActive: function isQuestActive() {
      return useNodeStore().isInNodeEventTerm;
    },
    isBattleActive: function isBattleActive() {
      return useRaidStore().isInRaidBattleTerm && this.raidBossHp;
    },
    gumStr: function gumStr() {
      if (this.myZel < 1000000) return this.myZel;
      return 0;
      // return `1000000+`
    },
    currentStamina: function currentStamina() {
      return useUserStore().getStamina.currentStamina;
    },
    maxStamina: function maxStamina() {
      return useUserStore().getStamina.maxStamina;
    },
    sortLimitedMyItems: function sortLimitedMyItems() {
      var itemList = useConsumableStore().getLimitedMyItems;
      return itemList.sort(function (p, c) {
        if (p.until < c.until) return -1;
        if (p.until > c.until) return 1;
        return 0;
      });
    },
    elsPointImgUrl: function elsPointImgUrl() {
      return "".concat(this.$env.cdnUrl, "/rsc/item/consume_item/item_40004.png");
    },
    bpcPointImgUrl: function bpcPointImgUrl() {
      return "".concat(this.$env.cdnUrl, "/rsc/item/consume_item/item_40005.png");
    },
    userElsPoint: function userElsPoint() {
      return useConsumableStore().getMyBalance.elsPoint;
    },
    userBpcPoint: function userBpcPoint() {
      return useConsumableStore().getMyBalance.bpcPoint;
    }
  },
  watch: {
    $route: function $route() {
      this.isMenuShown = false;
    },
    isLoggedIn: {
      handler: function handler() {
        var _this = this;
        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (!process.server) {
                  _context.next = 2;
                  break;
                }
                return _context.abrupt("return");
              case 2:
                if (_this.isLoggedIn) {
                  _context.next = 4;
                  break;
                }
                return _context.abrupt("return");
              case 4:
                _context.next = 6;
                return useConsumableStore().fetchConsumeMyItems();
              case 6:
                useAuthStore().startTimer();
              case 7:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }))();
      },
      immediate: true
    }
  },
  beforeMount: function beforeMount() {
    var _this2 = this;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return Promise.all([useNodeStore().fetchNodes()]);
          case 2:
            if (!_this2.isLoggedIn) {
              _context2.next = 7;
              break;
            }
            _context2.next = 5;
            return useUserStore().fetchStamina();
          case 5:
            _context2.next = 7;
            return useUserStore().fetchRecoveryStaminaCount();
          case 7:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    useAuthStore().stopTimer();
  },
  methods: {
    toggleMenu: function toggleMenu() {
      this.isMenuShown = !this.isMenuShown;
    },
    requestMaticNetwork: function requestMaticNetwork() {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return useWalletStore().switchNetwork(MaticNetwork);
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    requestEthNetwork: function requestEthNetwork() {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return useWalletStore().switchNetwork(EthereumNetwork);
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    requestHomeverseNetwork: function requestHomeverseNetwork() {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return useWalletStore().switchNetwork(HomeverseNetwork);
            case 2:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    requestOasysNetwork: function requestOasysNetwork() {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return useWalletStore().switchNetwork(OasysMainnet);
            case 2:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    changeMaticNetwork: function changeMaticNetwork() {
      // try {
      //   switchNetwork(MaticNetwork)
      // } catch (e) {
      //   this.isNoneSwitchNetworkModal = true
      //   console.error(e)
      // }
    },
    changeHomeverseNetwork: function changeHomeverseNetwork() {
      // try {
      //   useWalletStore().switchNetwork(HomeverseNetwork)
      //   // switchNetwork(HomeverseNetwork)
      // } catch (e) {
      //   this.isNoneSwitchNetworkModal = true
      //   console.error(e)
      // }
    },
    changeOasysNetwork: function changeOasysNetwork() {
      // try {
      //   useWalletStore().switchNetwork(OasysMainnet)
      //   //switchNetwork(OasysMainnet)
      // } catch (e) {
      //   console.error(e)
      // }
    },
    changeEthNetwork: function changeEthNetwork() {
      this.isNoneSwitchNetworkModal = true;
    },
    isLinkActive: function isLinkActive(name) {
      if (name === 'home') {
        return this.$route.name.startsWith('index___');
      }
      return this.$route.name.startsWith(name);
    },
    setLang: function setLang(locale) {
      this.$router.push(this.switchLocalePath(locale.code));
      this.$i18n.setLocaleCookie(locale.code);
      this.closeLangDropdown();
    },
    openLangDropdown: function openLangDropdown() {
      this.isLangDropdownShown = true;
    },
    closeLangDropdown: function closeLangDropdown() {
      this.isLangDropdownShown = false;
    },
    toggleAccordionMenu: function toggleAccordionMenu() {
      this.accordionMenuOpen = !this.accordionMenuOpen;
    },
    recoveryStaminaModalOpen: function recoveryStaminaModalOpen() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return useConsumableStore().fetchLimitedMyItems();
            case 2:
              _this3.isRecoveryStaminaModalShown = true;
            case 3:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    }
  }
};